import React from 'react';
import './CertificateView.css';

const ISSUER_NAME = 'Infobloom';
const PLATFORM_NAME = 'LearnWithInfobloom';

export default function CertificateView({ certificate, userName, onClose }) {
  const completedAt = certificate?.completedAt?.toDate
    ? certificate.completedAt.toDate()
    : (certificate?.completedAt ? new Date(certificate.completedAt) : new Date());
  const dateStr = completedAt.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="certificate-view-overlay" onClick={onClose}>
      <div className="certificate-view-paper" onClick={(e) => e.stopPropagation()}>
        <div className="certificate-view-inner">
          <p className="certificate-view-label">Certificate of Completion</p>
          <p className="certificate-view-platform">{PLATFORM_NAME}</p>
          <p className="certificate-view-hereby">This is to certify that</p>
          <h2 className="certificate-view-name">{userName || 'the learner'}</h2>
          <p className="certificate-view-has">has successfully completed the course</p>
          <h3 className="certificate-view-course">{certificate?.courseTitle || 'Course'}</h3>
          <p className="certificate-view-date">Completed on {dateStr}</p>
          <div className="certificate-view-signature">
            <span className="certificate-view-signature-line" />
            <p className="certificate-view-signature-name">{ISSUER_NAME}</p>
            <p className="certificate-view-signature-title">{PLATFORM_NAME}</p>
          </div>
        </div>
        <div className="certificate-view-actions">
          <button type="button" className="certificate-view-btn certificate-view-btn-print" onClick={handlePrint}>
            Download / Print
          </button>
          <button type="button" className="certificate-view-btn certificate-view-btn-close" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
